import mapboxgl, {type MapOptions, type PopupOptions} from 'mapbox-gl';
import {openWindow} from "@/modules/utils";
import 'mapbox-gl/dist/mapbox-gl.css';

export interface GpsData {
    latitude: number
    longitude: number
}

export interface CoordinateDataset {
    popupContent?: string;
    gps: GpsData
}

export interface MapInitParams {
    container: HTMLElement | string;
    coordinates: CoordinateDataset[]
    options?: Partial<MapOptions>
}


const initMap = ({container, coordinates, options}: MapInitParams) => {
    const accessToken = import.meta.env.VITE_MAPBOX_PUBLIC_ACCESS_TOKEN || '';
    if (!accessToken) {
        console.error('mapboxgl {accessToken} not found');
        return;
    }

    mapboxgl.accessToken = accessToken;

    const markerHeight = 45;
    const markerRadius = 10;
    const linearOffset = 25;
    const popupMaxWidth = "500px";
    const popupOptions: PopupOptions = {
        closeButton: false, closeOnClick: false, closeOnMove: false,
        focusAfterOpen: true,
        maxWidth: popupMaxWidth,
        offset: {
            'top': [0, 0],
            'top-left': [0, 0],
            'top-right': [0, 0],
            'bottom': [0, -markerHeight],
            'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
            'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
            'left': [markerRadius, (markerHeight - markerRadius) * -1],
            'right': [-markerRadius, (markerHeight - markerRadius) * -1]
        },
    };

    const map = new mapboxgl.Map({
        container: container,
        interactive: true,
        // style: 'mapbox://styles/mapbox/streets-v12',
        style: 'mapbox://styles/mapbox/standard',
        center: [coordinates[0].gps.longitude, coordinates[0].gps.latitude],
        pitch: 60,
        bearing: -30,
        language: 'fr',
        boxZoom: true,
        dragRotate: true,
        keyboard: true,
        touchZoomRotate: true,
        // zoom: 16,
        ...options
    })

    map.setLanguage('fr');

    const onClicked = (gps: GpsData) => {
        openWindow(
            `https://www.google.com/maps/search/?api=1&query=${gps.latitude},${gps.longitude}`,
            {assignOnFail: true}
        )
    }

    for (let i = 0; i < coordinates.length; i++) {
        const {popupContent, gps} = coordinates[i];

        const marker = new mapboxgl.Marker({color: 'red', scale: 1.5}).setLngLat([gps.longitude, gps.latitude]).addTo(map);
        marker.getElement().addEventListener('click', function () {
            onClicked(gps);
        })

        const popup = new mapboxgl.Popup(popupOptions)
            .setLngLat([gps.longitude, gps.latitude])
            .setHTML(popupContent)
            .setMaxWidth(popupMaxWidth)
            .addTo(map);

        popup.getElement().addEventListener('click', function () {
            onClicked(gps);
        })
    }

    return map;
}

const CustomMap = {
    init: initMap,
}

export default CustomMap;